import CyclingCache from "../cache/CyclingCache";
import MonsterCharacter from "./MonsterCharacter";

export default class MonsterCharacterCache extends CyclingCache {
    constructor() {
        super();

        /**
         * @constant
         * @type {number}
         */
        this.initialCacheSize = 50;
        /**
         * @constant
         * @type {number}
         */
        this.growAmount = 15;
    }

    /**
     * @override
     * @returns {number}
     */
    getGrowAmount() {
        return this.growAmount;
    }

    /**
     * @override
     * @returns {number}
     */
    getInitialSize() {
        return this.initialCacheSize;
    }

    /**
     * @override
     * @returns {MonsterCharacter}
     */
    createInstance() {
        return new MonsterCharacter();
    }    
}